export enum UserRoleOfUnion {
    UnionManager  = 4 ,
    UnionIssuingManager = 5,
    UnionIssuingResponsible = 6,
    UnionSecretariat = 7,
    UnionExpert = 8,
    UnionJahadExpert = 9,
    UnionTreasurer = 10,
    UnionViceManager = 1012,
    UnionExecutiveManager = 1013,
}

